export default __webpack_public_path__ + "static/media/Bezel_Black_Gold.03a81126.png";